import { useState } from "react"
import Box from "@mui/material/Box"
import CustomButton from "@/components/custom-button"
import { useDestroyApplianceControl } from "@/hooks/use-appliance-control"


export default function DestroyApplianceControlForm({
    applianceId,
    applianceControlId,
}: {
    applianceId: number,
    applianceControlId: number,
}) {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    const mutation = useDestroyApplianceControl(applianceControlId, applianceId)

    return (
        <Box>
            <Box display="flex" justifyContent="center" gap={1}>
                {!confirmation &&
                    <CustomButton
                        variant="outlined"
                        color="error"    
                        text="Smazat zásuvku"
                        onClick={() => setConfirmation(true)}
                    />
                }
                {confirmation &&
                    <>
                        <CustomButton
                            color="error" 
                            text="Potvrdit"
                            disabled={mutation.isPending}
                            onClick={() => mutation.mutate()}
                        />
                        <CustomButton
                            variant="outlined"
                            text="Zrušit"
                            onClick={() => setConfirmation(false)}
                        />
                    </>
                }
            </Box>
            <Box>
                {mutation.isError ? (
                    <div>Došlo k chybě: {mutation.error.message}</div>
                ) : null}
            </Box>
        </Box>
    )
}
